import {
  BATCH_MSG_TYPE,
  COMMON_HANDLE_TYPE,
  DATA_DELIM,
  MESSAGE_DELIM
} from '../constants/common-enums';

let _parentUrl = '';
const _handlers = [];
let _allowableDomains = [];
let _parentWindow = null;

const isHybridImplementation = userAgent => {
  userAgent = userAgent.toLowerCase();
  const safari = /safari/i.test(userAgent);
  const iOS = /iphone|ipod|ipad/i.test(userAgent);
  const isIOSWebview = iOS && !safari;
  const isAndroidWebview = /wv/i.test(userAgent);
  const isVisaSDKLite = userAgent.indexOf('vco_sdk') !== -1;
  const isVisaHybridSDKLite = userAgent.indexOf('vco_hsdk') !== -1;
  return isVisaSDKLite || isVisaHybridSDKLite || isIOSWebview || isAndroidWebview;
};

// this will replace event name '.' to '_', per spec 0.53 this method is no longer needed.
export const _getHandlerKey = msgType => msgType;

export const _getHandler = msgType => {
  const handlerArray = _handlers || [];
  return handlerArray[_getHandlerKey(msgType)] || handlerArray[COMMON_HANDLE_TYPE];
};

export const _dispatch = e => {
  const n = _allowableDomains.length;
  let i = 0;
  let acceptable = false;

  for (; i < n; i++) {
    if (e.origin === _allowableDomains[i]) {
      acceptable = true;
      break;
    }
  }

  // [handler]--[data]
  if (acceptable && e.data.indexOf) {
    const data = e.data;
    let callback;
    let payload = [];
    let type;

    if (data.indexOf(DATA_DELIM) > 0) {
      payload = data.split(DATA_DELIM);
    }

    // must have at least handler and data payload
    if (payload.length > 1) {
      type = payload.shift();
      callback = _getHandler(type);
      // TODO: figure out if there's a valid "payload[1]"?
      if (typeof callback === 'function') {
        callback(payload[0], type);
      }
    } else {
      /* eslint-disable-next-line no-console */
      console.warn('message contained no handler or data payload');
    }
  }
};

const _send = options => {
  let messageString;
  let parentOrigin;

  /*TODO: Remove these debugging logs before release-branch merge
  console.groupCollapsed('SRC Sys-=-Send'); // eslint-disable-line
  console.log('--- Parent Window --- '); // eslint-disable-line
  console.log(_parentWindow); // eslint-disable-line
  console.log('--- Send options --- '); // eslint-disable-line
  console.log(JSON.stringify(options)); // eslint-disable-line
  console.groupEnd(); // eslint-disable-line */

  if (_parentUrl && options.type) {
    parentOrigin = _parentUrl.split('/', 3).join('/');
    if (window.postMessage) {
      messageString = _getHandlerKey(options.type);
      if (options.type === BATCH_MSG_TYPE) {
        messageString = '';
        messageString += options.data.join(MESSAGE_DELIM);
      } else {
        options.data = options.data || {}; // avoid undefined
        // VCO-10106: JSON.stringify, avoid TypeError: Converting circular structure to JSON
        const obj = options.data;

        // Need to ensure we arent post messaging any access tokens
        if (obj.data && obj.data.access_token) {
          delete obj.data.access_token;
        }

        // Note: cache should not be re-used by repeated calls to JSON.stringify.
        let cache = [];
        //messageString += DATA_DELIM + JSON.stringify(options.data);
        messageString +=
          DATA_DELIM +
          JSON.stringify(obj, (key, value) => {
            if (typeof value === 'object' && value !== null) {
              if (cache.indexOf(value) !== -1) {
                // Duplicate reference found
                try {
                  // If this value does not reference a parent it can be deduped
                  return JSON.parse(JSON.stringify(value));
                } catch (error) {
                  // discard key if value cannot be deduped
                  return undefined;
                }
              }
              // Store value in our collection
              cache.push(value);
            }
            return value;
          });
        cache = null; // Enable garbage collection
      }

      options.error = options.error || {}; // avoid undefined
      messageString += DATA_DELIM + JSON.stringify(options.error);

      if (options.sdkOptions) {
        messageString += DATA_DELIM + JSON.stringify(options.sdkOptions);
      }

      _parentWindow.postMessage(messageString, parentOrigin);
      return true;
    }
  }

  return false;
};

const _init = options => {
  options = options || {};
  _parentUrl = options.parentUrl;

  /*TODO: Remove these debugging logs before release-branch merge
  console.groupCollapsed('SRC Sys-=-init()'); // eslint-disable-line
  console.log('SRC Sys -- Parent Url --'); // eslint-disable-line
  console.log(_parentUrl); // eslint-disable-line
  console.log('SRC Sys -- Init options--'); // eslint-disable-line
  console.log(JSON.stringify(options)); // eslint-disable-line
  console.groupEnd(); // eslint-disable-line */

  if (_parentUrl) {
    if (window.addEventListener) {
      window.addEventListener('message', _dispatch, false);
    } else if (window.attachEvent) {
      window.attachEvent('onmessage', _dispatch);
    }
    // for new window, we need to have sdk-domain as well
    _allowableDomains = [_parentUrl.split('/', 3).join('/')];
    if (options.domain) {
      _allowableDomains.push(options.domain);
    }
    // close the window if the user tries to reload/refresh
    if (window.opener && window !== window.opener) {
      _parentWindow = window.opener;

      const ua = window.navigator.userAgent;
      const isIOS = /iP(ad|od|hone)/i.test(ua);
      window[isIOS ? 'onpagehide' : 'onbeforeunload'] = () => {
        const popupMessageObject = {
          data: {},
          type: 'cancel'
        };
        !isHybridImplementation(ua) && _send(popupMessageObject);
      };
    } else {
      _parentWindow = window.parent;
    }
  }
};

export const _addHandler = (msgType, fn, context) => {
  _handlers[_getHandlerKey(msgType)] = (rawResponse, type) => {
    fn.call(context, JSON.parse(rawResponse), type);
  };
};

const _bind = (msgType, fn, context) => {
  if (!_getHandler(msgType)) {
    _addHandler(msgType, fn, context);
  }
};

const _unbind = msgType => {
  delete _handlers[_getHandlerKey(msgType)];
};

const PostMessage = {
  bind: _bind,
  init: _init,
  send: _send,
  unbind: _unbind
};

export default PostMessage;
